const STORAGE_VERSION = 1;

interface VersionedValue<T> {
  version: number;
  value: T;
}

export function readPersisted<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;

    const parsed = JSON.parse(raw) as VersionedValue<T> | T;
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'version' in parsed &&
      'value' in parsed
    ) {
      return parsed.version === STORAGE_VERSION ? parsed.value : fallback;
    }
    return parsed as T;
  } catch (error) {
    console.warn(`Unable to read persisted value "${key}"`, error);
    return fallback;
  }
}

export function writePersisted<T>(key: string, value: T): void {
  try {
    const payload: VersionedValue<T> = { version: STORAGE_VERSION, value };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (error) {
    console.warn(`Unable to persist value "${key}"`, error);
  }
}

export function removePersisted(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn(`Unable to remove persisted value "${key}"`, error);
  }
}

export function setPreferenceCookie(name: string, value: string, maxAge = 31536000): void {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}
